import { useSetRecoilState } from 'recoil';
import { stageParameterState } from 'features/morphing/state/stageParameterAtoms';

export const useResetValues = () => {
  const setStageParameter = useSetRecoilState(stageParameterState);

  const resetValues = () => {
    setStageParameter({
      name: '',
      controlPoints: { x: 0, y: 0, z: 0 },
      morphingMin: { x: 0, y: 0, z: 0 },
      morphingMax: { x: 0, y: 0, z: 0 },
      ySymmetry: false,
      targetControlPointsX: { start: 0, stop: 0 },
      targetControlPointsY: { start: 0, stop: 0 },
      targetControlPointsZ: { start: 0, stop: 0 },
      morphingDirection: 'x',
      morphingParameter: { lower: 0, upper: 0 },
    })
  };

  return resetValues;
};
